import { getEndpoint } from "@api-routes/endpoint";

const CONTACTS_MS_NAME = "add-ons";

export const postAddonRoute = () => `${getEndpoint(CONTACTS_MS_NAME)}add-ons`;

export const deleteAddonRoute = (addonId: number, query: string) =>
    `${getEndpoint(CONTACTS_MS_NAME)}add-ons/${addonId}${query}`;
